"use client";

import React, { ReactNode } from "react";

import { cn } from "@/lib/utils";
import { useDataContext } from "@/app/_context";

export default function HighlightsPlaylistColumn({
  children,
}: {
  children: ReactNode;
}) {
  const { currentPlaylist } = useDataContext();
  return (
    <div
      id="HighLights_Playlist_Column"
      className={cn(
        "bg-background",
        "flex flex-col min-w-[320px] relative top-0 flex-1 min-h-0 md:flex-initial md:h-full text-foreground border-l border-muted dark:border-muted/20",
        "md:min-w-[450px]", // For screens min-width 1025px
        {
          "md:flex-[0.72] transition-[margin-bottom] cubic-bezier-[0,0.21,0.355,1] md:min-h-[39vh]":
            currentPlaylist?.length > 1,
        },
      )}
    >
      {children}
    </div>
  );
}
